import { motion } from "framer-motion";

const ease = [0.25, 1, 0.5, 1];

export const Reveal = ({ children, delay = 0, y = 20, className = "", ...props }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease, delay }}
      className={className}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
